// Bildzeichen des Rahmens, Pfade aus Entwurf v4 (design/build.py, 24er-Raster).
//
// Inline statt einer Symbolbibliothek: der Rahmen braucht eine Handvoll
// Zeichen, und eine Abhaengigkeit fuer acht Pfade waere mehr Last als Nutzen.
// Die Zeichen sind immer stumm; den Namen traegt der Text oder das Label daneben.

import type { ReactNode } from 'react';

const PFADE = {
  kontakte: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5" />
      <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.8c1.9.7 3.1 2.4 3.5 5.2" />
    </>
  ),
  uhr: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  lesezeichen: <path d="M6.5 3.5h11v17l-5.5-4-5.5 4z" />,
  stichwort: (
    <>
      <path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1.4 1.4 0 0 1 0 2l-6.7 6.7a1.4 1.4 0 0 1-2 0z" />
      <circle cx="8" cy="8" r="1.4" />
    </>
  ),
  // Person mit Etikett (Vorgabe Rollenkatalog: "PersonTag").
  rolle: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5 1.2 0 2.3.3 3.2.8" />
      <path d="M14 14.5h4.3l3.2 3.2-3.2 3.3H14z" />
    </>
  ),
  ebenen: (
    <>
      <path d="m12 3.5 8.5 4.5-8.5 4.5L3.5 8z" />
      <path d="m3.5 12 8.5 4.5 8.5-4.5M3.5 16l8.5 4.5 8.5-4.5" />
    </>
  ),
  // Datenqualitaet: ein Schild statt eines Hakens; der Haken las sich wie "erledigt".
  schild: <path d="M12 3.5 5 6.2v5.6c0 4.2 2.9 7.5 7 8.7 4.1-1.2 7-4.5 7-8.7V6.2z" />,
  menue: <path d="M4 7h16M4 12h16M4 17h16" />,
  // Schliessen des schmalen Menues (M-04).
  schliessen: <path d="M6 6l12 12M18 6 6 18" />,
  // Testversand (M-22): ein Papierflieger wie v4 "Send".
  senden: (
    <>
      <path d="M20.5 3.5 3.5 10.6l6.8 2.6 2.6 6.8z" />
      <path d="m20.5 3.5-10.2 9.7" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  // Kopieren in die Zwischenablage (wie die Kopfkarte des Kontakts).
  kopieren: (
    <>
      <rect x="8.5" y="8.5" width="11" height="12" rx="1.5" />
      <path d="M15.5 8.5v-3a1.5 1.5 0 0 0-1.5-1.5H6A1.5 1.5 0 0 0 4.5 5.5v10A1.5 1.5 0 0 0 6 17h2.5" />
    </>
  ),
  // Uebernommene Angabe (Rundgang 37): Fluent Link16Regular (MIT, @fluentui/react-icons),
  // als Flaeche im 16er-Raster und auf 24 hochgesetzt.
  verknuepft: (
    <path
      transform="scale(1.5)"
      fill="currentColor"
      stroke="none"
      d="M9.5 4h1a3.5 3.5 0 0 1 .2 7H9.5a.5.5 0 0 1-.1-.99h.1l1-.01a2.5 2.5 0 0 0 .16-5H9.5a.5.5 0 0 1-.09-1zh1zm-4 0h1a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.5a.5.5 0 0 1 .09 1H5.5a3.5 3.5 0 0 1-.2-7zh1zm0 3h5a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1z"
    />
  ),
  // Filterknopf an der Kontaktliste (DESIGN L14-03): ein Trichter wie v4 "Filter".
  filter: <path d="M4 5h16l-6.2 7.4V19l-3.6-1.8v-4.8z" />,
  // Suchhilfe als Symbolknopf am schmalen Feld (DESIGN L14-04).
  hilfe: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M9.7 9.5a2.4 2.4 0 1 1 3.3 2.2c-.6.3-1 .8-1 1.5v.5" />
      <path d="M12 16.6v.1" />
    </>
  ),
  suche: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-4.2-4.2" />
    </>
  ),
  // Ein Link, der einen neuen Tab oeffnet (DESIGN B10): Kasten mit Pfeil nach aussen wie v4 "Open".
  neuerTab: (
    <>
      <path d="M13.5 4.5h6v6M19.5 4.5l-8 8" />
      <path d="M17.5 13.5v5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5" />
    </>
  ),
} as const;

export type SymbolName = keyof typeof PFADE;

/** Ein stummes Bildzeichen in Schriftfarbe; die Groesse in rem waechst mit dem Textzoom. */
export function Symbol({ name, groesse = '1.125rem' }: { readonly name: SymbolName; readonly groesse?: string }): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      style={{ width: groesse, height: groesse, flexShrink: 0 }}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {PFADE[name]}
    </svg>
  );
}

/**
 * Das Zeichen hinter einem Link, der einen neuen Tab oeffnet (DESIGN B10): rund
 * 12 px auf 14 px Schrift, auf der Schriftmitte. In em und mit line-height 0, damit
 * es mit dem Text des Links waechst und die Zeile bei 200 % nicht hoeher macht
 * (B19); in rem wuchs es ueber die Zeile hinaus. Stumm; dass ein neuer Tab
 * aufgeht, sagt der zugaengliche Name des Links.
 */
export function NeuerTabZeichen(): ReactNode {
  return (
    <span style={{ display: 'inline-block', lineHeight: 0, marginInlineStart: '0.25em', verticalAlign: '-0.05em' }}>
      <Symbol name="neuerTab" groesse="0.86em" />
    </span>
  );
}
